
import { Component, Vue, Prop } from 'vue-property-decorator'
import { OzBoxColors } from 'library/v4/components/OzBox.vue'
@Component({})
export default class OzPopoverTip extends Vue {
  OzBoxColors = OzBoxColors
  @Prop({ default: OzBoxColors.Primary }) color!: OzBoxColors
  @Prop({ default: 'auto' }) darkMode!: false | true | 'auto'
  @Prop({ default: () => [] }) pathClasses!: string[]
  @Prop({ default: false }) isFirefox!: boolean
}
